import { getBaseGSTInvoiceURL, xlCol, xlColq } from '../../../common/constants'
import { getPaymentTypeBackground, getStatusBackground } from '../../../common/helper'
import { safeAdd } from '../../../common/mathHelper'
import { accumulateTotals } from '../NonMovementTable/utilFucntions'

export const TOTAL_SUMMARY_FIELDS = [
  'TAmount',
  'TBookingGST',
  'TBookingOtherCharge',
  'TCartageAmount',
  'TCartageDelivery',
  'TDeliveryCartage',
  'TDeliveryGST',
  'TDeliveryHamali',
  'TDelotherchg',
  'TDemurrageChg',
  'TDocumentChg',
  'TFreight',
  'THamaliCharges',
  'THomeDeliveryChg',
  'TLRCount',
  'TNetAmount',
  'TOperatorHamaliChg',
  'TOutStanding',
  'TUnits',
  'TValuation',
]
const TOTAL_FIELDS = [
  'Units',
  'Freight',
  'DocumentCharges',
  'CartageAmount',
  'HamaliCharges',
  'OperatorHamaliChg',
  'Valuation',
  'OtherCharge',
  'BookingGST',
  'DeliveryHamali',
  'DeliveryCartage',
  'DemurrageChg',
  'DeliveryGST',
  'NetAmount',
  'OutStanding',
]
export const partyAsList = [
  { id: 0, name: 'Both - Sender & Receiver' },
  { id: 1, name: 'Sender' },
  { id: 2, name: 'Receiver' },
  { id: 3, name: 'Payment Responsibility' },
]

export const headerTblDefs = [
  { header: 'Company', dataKey: 'companyName', xlCol },
  { header: 'Payment Mode', dataKey: 'paymentModeName', xlCol },
  { header: 'City', dataKey: 'partyCityName', xlCol },
  { header: 'Party', dataKey: 'partyName', xlCol },
  { header: 'Show Party As', dataKey: 'partyAsName', xlCol: xlColq },
]
export const excelHeader = [
  { field: 'fromDate', header: 'From Date' },
  { field: 'toDate', header: 'To Date' },
  { field: 'reportView', header: 'Report View' },
  { field: 'companyName', header: 'Select Company' },
  { field: 'paymentModeName', header: 'Payment Mode' },
  { field: 'partyCityName', header: 'Select City' },
  { field: 'partyName', header: 'Select Party' },
  { field: 'partyAsName', header: 'Show Party As', xlCol: xlColq },
]
export const detailedTblColDefs = [
  { id: 1, header: 'SN', exportHead: 'Serial\nNumber', dataKey: 'SN', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '35px' },
  { id: 2, header: 'LR No.\nMan LR No.', exportHead: 'LR Number\nManual LR Number', dataKey: 'LRNO^^ManualLRNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '120px', isSortIcon: true },
  { id: 3, header: 'Formatted LR No.\nMan LR No.', exportHead: 'Formatted LR Number\nManual LR Number', dataKey: 'FormattedLRNO^^ManualLRNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '120px', isSortIcon: true },
  { id: 4, header: 'Formatted\nLR No.', exportHead: 'Formatted LR No.', dataKey: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '120px', isSortIcon: true },
  { id: 5, header: 'Bkg. Date\nBkg. Time', exportHead: 'Booking Date\nBooking Time', dataKey: 'BookingDate^^BookingTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '110px', isSortIcon: true },
  { id: 6, header: 'Src. City\nSrc. Br.', exportHead: 'Source City\nSource Branch', dataKey: 'SourceCity^^SourceBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '180px', isSortIcon: true },
  { id: 7, header: 'Dest. City \nDest. Br.', exportHead: 'Destination City\nDestination Branch', dataKey: 'DestinationCity^^DestinationBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '180px', isSortIcon: true },
  { id: 8, header: 'Sndr.Party\nSndr. No.', exportHead: 'Sender Party\nSender Number', dataKey: 'SenderParty^^SenderMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '130px', isSortIcon: true },
  { id: 9, header: 'Sndr.GSTIN\nSndr.eMail', exportHead: 'Sender GSTIN\nSender Email', dataKey: 'SenderGSTN^^SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, minWidth: '130px', isSortIcon: true },
  { id: 10, header: 'Rcvr.Party\nRcvr. No.', exportHead: 'Receiver Party\nReceiver Number', dataKey: 'ReceiverParty^^ReceiverMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '130px', isSortIcon: true },
  { id: 11, header: 'Rcvr.GSTIN\nRcvr. eMail', exportHead: 'Receiver GSTIN\nReceiver Email', dataKey: 'ReceiverGSTN^^ReceiverEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlCol, minWidth: '130px', isSortIcon: true },
  { id: 12, header: 'Pymt.\nResp', exportHead: 'Payment Responsibility', dataKey: 'PaymentResponsibility', isSelected: true, isDefault: true, isMandatory: false, xlCol: xlCol, minWidth: '125px', isSortIcon: true },
  { id: 13, header: 'Pymt.\nType', exportHead: 'Payment PayType', dataKey: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '125px', isSortIcon: true },
  { id: 14, header: 'Item', exportHead: 'Item', dataKey: 'Item', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '110px', isSortIcon: true },
  { id: 15, header: 'Status', exportHead: 'Status', dataKey: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlCol, minWidth: '110px', isSortIcon: true },
  { id: 16, header: 'Booking GST Invoice No.', exportHead: 'Booking GST Invoice No.', dataKey: 'BookingGSTInvoiceNo', isSelected: false, isDefault: false, isMandatory: false, xlCol: xlCol, minWidth: '110px', isSortIcon: true, isExcelLink: true, link: 'bkgInvoiceLink' },
  { id: 17, header: 'Booking GST Invoice Date', exportHead: 'Booking GST Invoice Date', dataKey: 'BookingGSTInvoiceDate', isSelected: false, isDefault: false, isMandatory: false, xlCol: xlCol, minWidth: '110px', isSortIcon: true },
  { id: 18, header: 'Booking GST Invoice Amount', exportHead: 'Booking GST Invoice Amount', dataKey: 'BookingGSTInvoiceAmount', isSelected: false, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '110px', isSortIcon: true },
  { id: 19, header: 'Delivery GST Invoice No.', exportHead: 'Delivery GST Invoice No.', dataKey: 'DeliveryGSTInvoiceNo', isSelected: false, isDefault: false, isMandatory: false, xlCol: xlCol, minWidth: '110px', isSortIcon: true, isExcelLink: true, link: 'delInvoiceLink' },
  { id: 20, header: 'Delivery GST Invoice Date', exportHead: 'Delivery GST Invoice Date', dataKey: 'DeliveryGSTInvoiceDate', isSelected: false, isDefault: false, isMandatory: false, xlCol: xlCol, minWidth: '110px', isSortIcon: true },
  { id: 21, header: 'Delivery GST Invoice Amount', exportHead: 'Delivery GST Invoice Amount', dataKey: 'DeliveryGSTInvoiceAmount', isSelected: false, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '110px', isSortIcon: true },
  { id: 22, header: 'Units', exportHead: 'Units', dataKey: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 23, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', dataKey: 'Freight', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 24, header: 'Doc.\nChrg.', exportHead: 'Doc. Chrg.', dataKey: 'DocumentCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 25, header: 'Cart.\nChrg.', exportHead: 'Cart. Chrg.', dataKey: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 26, header: 'Ham.\nChrg.', exportHead: 'Ham. Chrg.', dataKey: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 27, header: 'Op.\nHam.', exportHead: 'Op. Ham.', dataKey: 'OperatorHamaliChg', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 28, header: 'Val.\nChrg.', exportHead: 'Val. Chrg.', dataKey: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 29, header: 'Oth.\nChrg.', exportHead: 'Oth. Chrg.', dataKey: 'OtherCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 30, header: 'Bkg.\nGST', exportHead: 'Bkg. GST', dataKey: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 31, header: 'Net.\nAmt.', exportHead: 'Net. Amt.', dataKey: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 32, header: 'Del.\nHam.', exportHead: 'Del. Ham.', dataKey: 'DeliveryHamali', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 33, header: 'Del.\nCart.', exportHead: 'Del. Cart.', dataKey: 'DeliveryCartage', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 34, header: 'Dem.\nChrg.', exportHead: 'Dem. Chrg.', dataKey: 'DemurrageChg', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 35, header: 'Del.\nGST.', exportHead: 'Del. GST.', dataKey: 'DeliveryGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { id: 36, header: 'Net O/S\n Amt.', exportHead: 'Net O/S Amt.', dataKey: 'OutStanding', isSelected: true, isDefault: true, isMandatory: true, xlCol: xlColq, minWidth: '70px', isSortIcon: true }
];
export const partyBookingSummaryHeader = [
  { field: 'PayType', header: 'Payment Type', exportHead: 'Payment Type', xlCol: { dataType: 'string' }, align: 'left', weight: 90, isSortIcon: true },
  { field: 'Units', header: 'Item Quantity', exportHead: 'Item Quantity', xlCol: { dataType: 'number' }, align: 'right', weight: 80, isSortIcon: true },
  { field: 'Freight', header: 'Freight', exportHead: 'Freight', xlCol: { dataType: 'number' }, align: 'right', weight: 80, isSortIcon: true },
  { field: 'DocumentCharges', header: 'Doc Charge', exportHead: 'Doc Charge', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'CartageAmount', header: 'Cartage', exportHead: 'Cartage', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'HamaliCharges', header: 'Hamali', exportHead: 'Hamali', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'OperatorHamaliChg', header: 'Op. Hamali', exportHead: 'Op. Hamali', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'Valuation', header: 'Valuation Charge', exportHead: 'Valuation Charge', xlCol: { dataType: 'number' }, align: 'right', weight: 80, isSortIcon: true },
  { field: 'BookingGST', header: 'Booking GST', exportHead: 'Booking GST', xlCol: { dataType: 'number' }, align: 'right', weight: 80, isSortIcon: true },
  { field: 'NetAmount', header: 'Net. Amt.', exportHead: 'Net. Amt.', xlCol: { dataType: 'number' }, align: 'right', weight: 90, isSortIcon: true },
  { field: 'DeliveryHamali', header: 'Del. Ham.', exportHead: 'Del. Ham.', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'DeliveryCartage', header: 'Del. Cart.', exportHead: 'Del. Cart.', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'DemurrageChg', header: 'Dem. Chrg.', exportHead: 'Dem. Chrg.', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'DeliveryGST', header: 'Delivery GST', exportHead: 'Delivery GST', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
  { field: 'OutStanding', header: 'Net O/S Amt.', exportHead: 'Net O/S Amt.', xlCol: { dataType: 'number' }, align: 'right', weight: 70, isSortIcon: true },
]
export const summaryTblColDefs = [
  { header: 'Serial Number', exportHead: 'Serial Number', dataKey: 'SN', xlCol: xlCol, minWidth: '70px', isSortIcon: true },
  { header: 'Party Name', exportHead: 'Party Name', dataKey: 'partyName', xlCol: xlCol, minWidth: '130px', isSortIcon: true },
  { header: 'LR Count', exportHead: 'LR Count', dataKey: 'TLRCount', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Units', exportHead: 'Units', dataKey: 'TUnits', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Freight Charge', exportHead: 'Freight Charge', dataKey: 'TFreight', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Document Charge', exportHead: 'Document Charge', dataKey: 'TDocumentChg', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Cartage Charge', exportHead: 'Cartage Charge', dataKey: 'TCartageAmount', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Hamali Charge', exportHead: 'Hamali Charge', dataKey: 'THamaliCharges', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Operator Hamali', exportHead: 'Operator Hamali', dataKey: 'TOperatorHamaliChg', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Valuation Charge', exportHead: 'Valuation Charge', dataKey: 'TValuation', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Other Charge', exportHead: 'Other Charge', dataKey: 'TBookingOtherCharge', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Booking GST', exportHead: 'Booking GST', dataKey: 'TBookingGST', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net Amount', dataKey: 'TNetAmount', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Delivery Hamali', exportHead: 'Delivery Hamali', dataKey: 'TDeliveryHamali', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Delivery Cartage', exportHead: 'Delivery Cartage', dataKey: 'TDeliveryCartage', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Demurrage Charge', exportHead: 'Demurrage Charge', dataKey: 'TDemurrageChg', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Delivery GST', exportHead: 'Delivery GST', dataKey: 'TDeliveryGST', xlCol: xlColq, minWidth: '70px', isSortIcon: true },
  { header: 'Net Outstanding Amount', exportHead: 'Net Outstanding Amount', dataKey: 'TOutStanding', xlCol: xlColq, minWidth: '70px', isSortIcon: true }
];

export const groupDataDetailed = (list, headers, intCompanyID) => {
  const result = list.map((a, i) => ({
    ...a,
    SN: i + 1,
    dataType: 'entry',
    bkgInvoiceLink: a.IsBookingInvoice ? getBaseGSTInvoiceURL(a?.BookingID, 'B', intCompanyID) : '',
    delInvoiceLink: a.IsDeliveryInvoice ? getBaseGSTInvoiceURL(a?.BookingID, 'D', intCompanyID) : '',
    //  isRowData: true,
    PayType_view: (
      <span
        style={{
          fontSize: '12px',
          padding: '4px 10px',
          borderRadius: '30px',
          width: '95px',
          backgroundColor: getPaymentTypeBackground(a.PayType),
        }}
      >
        {a.PayType}
      </span>
    ),
    STATUS_view: (
      <span
        style={{
          paddingTop: '2px',
          fontSize: '12px',
          backgroundColor: getStatusBackground(a.STATUS),
          padding: '4px 10px',
          borderRadius: '30px',
        }}
      >
        {a.STATUS}
      </span>
    ),
    BookingGSTInvoiceNo_view: a.IsBookingInvoice ? (
      <a
        href={getBaseGSTInvoiceURL(a?.BookingID, 'B', intCompanyID)}
        style={{ color: 'blue', textDecoration: 'underline' }}
        target="_blank"
      >
        {a.BookingGSTInvoiceNo}
      </a>
    ) : (
      ''
    ),
    DeliveryGSTInvoiceNo_view: a.IsDeliveryInvoice ? (
      <a
        href={getBaseGSTInvoiceURL(a?.BookingID, 'D', intCompanyID)}
        style={{ color: 'blue', textDecoration: 'underline' }}
        target="_blank"
      >
        {a.DeliveryGSTInvoiceNo}
      </a>
    ) : (
      ''
    ),
  }))
  const grandTotal = accumulateTotals(list, TOTAL_FIELDS)
  result.push({
    SN: 'Total Booking',
    dataType: 'total',
    ...grandTotal,
    colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'STATUS') + 1 },
    align: { [headers[0].field]: 'right' },
  })
  return result
}
export const transformPartyBookingSummary = (data) => {
  const numericFields = [
  'Units', 'Freight', 'DocumentCharges', 'CartageAmount',
  'HamaliCharges', 'OperatorHamaliChg', 'Valuation',
  'BookingGST', 'NetAmount', 'DeliveryHamali', 'DeliveryCartage',
  'DemurrageChg', 'DeliveryGST', 'OutStanding',
]

  const grouped = data.reduce((acc, item) => {
    const key = item.PaymentTypeID ?? item.PayType ?? 'NA'
      ; (acc[key] ||= []).push(item)
    return acc
  }, {})

  const rows = []

  Object.values(grouped).forEach((group) => {
    const totals = Object.fromEntries(numericFields.map(f => [f, 0]))
    group.forEach(obj => {
      numericFields.forEach(key => {
        const val = Number(obj[key])
        if (!isNaN(val)) totals[key] += val
      })
    })
    rows.push({
      dataType: 'entry',
      PayType: group[0]?.PayType ?? 'NA',
      ...totals
    })
  })

  const grandTotals = Object.fromEntries(numericFields.map(f => [f, 0]))
  rows.forEach(row => {
    if (row.dataType !== 'entry') return
    numericFields.forEach(key => {
      const val = Number(row[key])
      if (!isNaN(val)) grandTotals[key] += val
    })
  })
  rows.push({
    dataType: 'total',
    PayType: 'Grand Total',
    ...grandTotals
  })

  return rows
}

export function groupDataDetailedSummary(list1 = [], list2 = [], partyAsId, headers) {
  const rows = []
  list1 = list1.map((item, index) => ({ ...item, SN: index + 1, dataType: 'entry', isRowData: true, partyName: item.SenderParty }))
  list2 = list2.map((item, index) => ({ ...item, SN: index + 1, dataType: 'entry', isRowData: true, partyName: item.RecParty }))
  const makeTotalRow = (sourceRows, label) => ({
    ...accumulateTotals(sourceRows, TOTAL_SUMMARY_FIELDS),
    dataType: 'total',
    isRowData: true,
    [headers[0].field]: label,
    colSpan: { [headers[0].field]: 2 },
    align: { [headers[0].field]: 'right' },
  })

  if (partyAsId === 0) {
    if (list1.length) {
      rows.push({
        [headers[0].field]: 'Sender Party Summary',
        dataType: 'subHeader',
        colSpan: { [headers[0].field]: headers.length },
      })
      rows.push(...list1)
      rows.push(makeTotalRow(list1, 'TOTAL: Sender Party'))
    }
    if (list2.length) {
      rows.push({
        [headers[0].field]: 'Receiver Party Summary',
        dataType: 'subHeader',
        colSpan: { [headers[0].field]: headers.length },
      })
      rows.push(...list2)
      rows.push(makeTotalRow(list2, 'TOTAL: Receiver Party'))
    }
    if (list1.length && list2.length) {
      rows.push(makeTotalRow([...list1, ...list2], 'GRAND TOTAL: Sender & Receiver Party'))
    }
  }

  if (partyAsId === 1) {
    rows.push(...list1)
    rows.push(makeTotalRow(list1, 'TOTAL: Sender Party Bookings & Deliveries'))
  }

  if (partyAsId === 2) {
    rows.push(...list2)
    rows.push(makeTotalRow(list2, 'TOTAL: Receiver Party Bookings & Deliveries'))
  }

  if (partyAsId === 3) {
    const map = new Map()
    const combiledList = [...list1, ...list2]
    combiledList.forEach((row) => {
      const key = row.partyName

      if (!map.has(key)) {
        map.set(key, { ...row })
      } else {
        const acc = map.get(key)
        TOTAL_SUMMARY_FIELDS.forEach((f) => {
          acc[f] = safeAdd(acc[f], Number(row[f] || 0))
        })
      }
    })
    const merged = Array.from(map.values())
    rows.push(...merged)
    rows.push(makeTotalRow(merged, 'TOTAL: Partywise Bookings & Deliveries'))
  }
  return rows
}